module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/terminal/terminal.component.html
// module id = ./src/app/routes/terminal/terminal.component.html
// module chunks = 9